export const jvBanks = [
    { label:"Alpha Bank",value:"Alpha Bank", id:"alpha"},
    { label:"Attica Bank",value:"Attica Bank",id:"attica"},
    { label:"Eurobank",value:"Eurobank",id:"eurobank"},
    { label:"Optima Bank",value:"Optima Bank",id:"optima"},
    { label:"Εθνική Τράπεζα",value:"Εθνική Τράπεζα",id:"nbg"},
    { label:"Παγκρήτια Τράπεζα",value:"Παγκρήτια Τράπεζα",id:"pancreta"}, 
    { label:"Τράπεζα Πειραιώς",value:"Τράπεζα Πειραιώς",id:"pireus"}, 
]